function NormalCell(props) {
    return (
        <td>
            <span className={props.hidden ? "text-muted" : ""}>
                { props.dataItem[props.field] }
            </span>
        </td>
    )
}

export default NormalCell;